export const relatedDocumentTypes = {
  labreport: { label: 'Laboratory Report', value: 'labreport' },
  radreport: { label: 'Radiology Report', value: 'radreport' },
  medhistory: { label: 'Medical History Record', value: 'medhistory' },
  prescription: { label: 'Prescription', value: 'prescription' },
  discharge: { label: 'Discharge Summary', value: 'discharge' },
  operative: { label: 'Operative Report', value: 'operative' },
  other: { label: 'Other', value: 'other' }
}

export const relatedDocumentEditOptions = {
  rename: { type: 'rename', label: 'Rename' },
  removeItem: { type: 'removeItem', label: 'Delete' }
}

export const attachedReportDocumentTypes = {
  DRAFT: { label: 'Draft Report', value: 'DRAFT' },
  FINALISED: { label: 'Final Report', value: 'FINALISED' },
  PRELIMINARY: { label: 'Preliminary Report', value: 'PRELIMINARY' },
  REVISED: { label: 'Revised Report', value: 'REVISED' }
}

export const attachedReportDocumentEditOptions = {
  rename: { type: 'rename', label: 'Rename' },
  changeType: { type: 'changeType', label: 'Change Type' }
  // removeItem: { type: 'removeItem', label: 'Delete' }
}
